module.exports = __webpack_public_path__ + "packs/media/images/close_white_icon-1f406c4beeb72434813979f340e42f34.png";